/**
 * User-facing name for the in-app (embedded) wallet. Privy is the underlying
 * provider but users should only ever see the MGT branding.
 */
export const MYGEOTOKENS_WALLET_DISPLAY_NAME = "MGT Wallet";

/**
 * Human-readable label for a given Privy walletClientType. Use this anywhere
 * the user needs to know which wallet they're currently using (Phantom
 * extension vs. the built-in MGT Wallet). Never leak the word "Privy".
 */
export function getWalletDisplayName(walletClientType?: string | null): string {
	const type = (walletClientType ?? "").toLowerCase();
	switch (type) {
		case "phantom":
			return "Phantom";
		case "solflare":
			return "Solflare";
		case "privy":
		case "smart_wallet":
		case "":
			return MYGEOTOKENS_WALLET_DISPLAY_NAME;
		default:
			return MYGEOTOKENS_WALLET_DISPLAY_NAME;
	}
}
